import { FC, ReactNode, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { InfoCell } from '@edikk-edikk/country-layout-black';
import { Link } from 'react-router';
import { RouterConfig } from '@edikk-edikk/shared';
import { AdvertServiceDataType } from '@edikk-edikk/country-frontend';
import { ServicePrice } from '#advertDetail/components';
import advertDetailServiceCss from '../../assets/service/service.module.scss';
import { useAdvertDetailContext } from '#advertDetail/hooks';

type PropsType = {
  serviceData: AdvertServiceDataType;
};

const Service: FC<PropsType> = ({
  serviceData,
}) => {
  const {
    advert: {
      city,
    },
  } = useAdvertDetailContext();

  const renderVisibleValue = (): ReactNode => {
    if (serviceData.isActive) {
      return <FormattedMessage defaultMessage="Yes" />;
    }
    return <FormattedMessage defaultMessage="Not" />;
  };

  const renderLabel = useCallback((): ReactNode => {
    if (!serviceData.category) {
      return serviceData.label;
    }

    return (
      <Link
        to={serviceData.category.url}
        state={{ routerConfig: RouterConfig.initForCategoryInCity(serviceData.category.id, city.id) }}
        className={advertDetailServiceCss.advertDetailService__label}
      >
        {serviceData.label}
      </Link>
    );
  }, [city.id, serviceData.category, serviceData.label]);

  return (
    <InfoCell
      additionalClassName={advertDetailServiceCss.advertDetailService}
      label={renderLabel()}
      value={(
        <div>
          {renderVisibleValue()}
          <ServicePrice price={serviceData.price} />
        </div>
      )}
      description={serviceData.comment}
    />
  );
};

export { Service };
